/**
 * useOutreachRows — one page of the Outreach tab's sourcing table
 * (GET /campaigns/{id}/outreach/creators). Keyed by every param
 * (tab/search/sort/page/limit) via campaignKeys.outreachRows so each
 * filter combination is its own cache slot, matching the roster tabs'
 * per-bucket keying convention.
 */
import { useQuery } from '@tanstack/react-query';
import type { OutreachRow } from '@discovr/types';
import { campaignKeys } from '../queryKeys';
import { retryOutreachQuery } from './outreachRetry';
import { fetchOutreachRows, type OutreachRowsParams } from '../api/outreachApi';

export function useOutreachRows(campaignId: string, params: OutreachRowsParams, enabled = true) {
  return useQuery<{ rows: OutreachRow[]; total: number }>({
    queryKey: campaignKeys.outreachRows(campaignId, params),
    queryFn: () => fetchOutreachRows(campaignId, params),
    enabled: enabled && !!campaignId,
    staleTime: 30_000,
    retry: retryOutreachQuery,
  });
}
